import React from 'react'
import { bodyLayoutVariants } from '../styles'

const { container } = bodyLayoutVariants()

const BodyLayout = ({ children }: any) => <div className={container()}>{children}</div>

export default BodyLayout
